export default __webpack_public_path__ + "static/heroSectionBg-65fdfe956df9c9d3ba240b53e854be9e.png";